export class AdspDeals{
  name: string;
  vizibl_deal_type: string;
  admin_state: string;
  deal_type: string;
  available_to_all: boolean;
  agencies: Array<any>;
  advertisers: Array<any>;

constructor() {
  this.available_to_all = true;
  this.agencies = [];
  this.advertisers = [];
}
}

export const AdspDealMediaOptions = [
  { value: "standard_display", label: "Standard Display" },
  { value: "amazon_mobile_display", label: "Amazon Mobile Display" },
  { value: "aap_mobile_app", label: "AAP Mobile App" },
  { value: "video", label: "Video" },
  { value: "unknown", label: "Others/Not Categorized" },
]

export const AdspDealTypeOptions = [
  { value: 'programmatic_guaranteed', label: 'Programmatic Guaranteed' },
  { value: 'private_auction', label: 'Private Auction' },
  { value: 'preferred', label: 'Preferred' },
  { value: 'amazon_audience_guaranteed', label: 'Amazon Audience Guaranteed' },
  { value: 'amazon_twitch_guaranteed', label: 'Amazon Twitch Guaranteed' },
  { value: 'amazon_audio_guaranteed', label: 'Amazon Audio Guaranteed' },
]

export const AdspDealPriceOptions = [
  { value: "fixed_cpm", label: "Fixed CPM" },
  { value: "flat_fees", label: "Flat Fees" },
  { value: "floor_rate", label: "Floor Rate" },
]

export const AdspDealStatusOptions = [
  { value: 'active', label: 'Active' },
  { value: 'upcoming', label: 'Upcoming' },
  { value: 'paused', label: 'Paused' },
  { value: 'expired', label: 'Expired' },
]

export const AdspDealAdminStateOptions = [
  { value: "pending", label: "Pending" },
  { value: "approved", label: "Approved" },
  { value: "rejected", label: "Rejected" },
  { value: "expired", label: "Expired" },
]
